//#region imports
import { InformationDialogComponent } from './../information-dialog/information-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { SaveService } from 'src/app/services/save.service';
import { ContactDetails } from './../../../model/save.model';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/services/globals';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { AppConstants } from 'src/app/app.constants';
//#endregion

@Component({
  selector: 'app-contact-information-dialog',
  templateUrl: './contact-information-dialog.component.html',
  styleUrls: ['./contact-information-dialog.component.css']
})
export class ContactInformationDialogComponent implements OnInit {
  //#region variables
  contactDetails: ContactDetails;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  code: string;
  dob: string;
  street: string;
  streetno:string;
  boxno: string;
  postcode: string;
  reason: any;
  contactPreference: any;
  selectedReason: any;
  selectedPreference: any;
  enableHelp = false;
  enableHelpButton = false;
  invalidCode = false;
  clientIdOrSimulationTokenPresent: boolean;
  emailpattern: any;
  simulationOptionChk = false;
  //#endregion

  //#region methods
  constructor(
    private matDialog: MatDialog, private dialogRef: MatDialogRef<ContactInformationDialogComponent>,
    private translate: TranslateService, private saveService: SaveService, private globals: Globals,
    private characteristicService: CharacteristicService) { 
      dialogRef.disableClose = false;
    }

  ngOnInit() {
    this.setData();
    this.setPreference();
    this.clientIdOrSimulationTokenPresent = this.characteristicService.getClientIdOrSimulationTokenPresent();
    this.contactDetails = this.saveService.getContactDetails();
    if (this.contactDetails) {
      this.firstName = this.contactDetails.FirstName;
      this.lastName = this.contactDetails.LastName;
      this.email = this.contactDetails.EmailAddress;
      this.phone = this.contactDetails.Telephone;
      this.code = this.contactDetails.PostalCode;
      this.dob = this.contactDetails.DateofBirth;
      this.street = this.contactDetails.StreetName;
      this.streetno = this.contactDetails.StreetNumber;
      this.boxno = this.contactDetails.BoxNumber;
    }
    this.emailpattern = AppConstants.EmailIdRegexPattern;
  }

  setPreference() {
    if(this.globals.isMobile)
    {
      const reason1 = this.translate.instant('Tab_Mobile_Help_Me_Reason1');
      const reason2 = this.translate.instant('Tab_Mobile_Help_Me_Reason2');
      // const reason3 = this.translate.instant('Tab_Mobile_Help_Me_Reason3');
      const reason4 = this.translate.instant('Tab_Mobile_Help_Me_Reason4');
      const reason5 = this.translate.instant('Tab_Mobile_Help_Me_Reason5');
      this.reason = [reason1, reason2, reason4, reason5];
      this.selectedReason = reason1; 
    }
    else{
      const reason1 = this.translate.instant('Tab_Help_Me_Reason1');
      const reason2 = this.translate.instant('Tab_Help_Me_Reason2');
      const reason3 = this.translate.instant('Tab_Help_Me_Reason3');
      const reason4 = this.translate.instant('Tab_Help_Me_Reason4');
      const reason5 = this.translate.instant('Tab_Help_Me_Reason5');
      this.reason = [reason1, reason2, reason3, reason4, reason5];
      this.selectedReason = reason1;
    }
    
    const contactPreference1 = this.translate.instant('Tab_Contact_Preferences1');
    const contactPreference2 = this.translate.instant('Tab_Contact_Preferences2');
    this.contactPreference = [contactPreference1, contactPreference2];
    this.selectedPreference = contactPreference1;
  }

  setData() {
    this.contactDetails = this.saveService.getContactDetails();
    if (this.contactDetails) {
      this.firstName = this.contactDetails.FirstName;
      this.lastName = this.contactDetails.LastName;
      this.email = this.contactDetails.EmailAddress;
      this.phone = this.contactDetails.Telephone;
      this.code = this.contactDetails.PostalCode;
      this.dob = this.contactDetails.DateofBirth;
      this.street = this.contactDetails.StreetName;
      this.streetno = this.contactDetails.StreetNumber;
      this.boxno = this.contactDetails.BoxNumber;
    }
  }

  onReasonChange(newValue) {
    // console.log(newValue);
    this.selectedReason = newValue;
  }

  onPreferenceChange(newValue) {
    // console.log(newValue);
    this.selectedPreference = newValue;
  }

  codeChange(enteredValue) {
    if (enteredValue.length === 4) {
      const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code);
      this.invalidCode = location.length > 0 ? false : true;
    }
  }

  onSubmit(myForm: NgForm) {
    let helpRequest;
    if (myForm.valid) {
      // console.log('valid form');
      this.globals.trackPageActivity += ';' + 'HELP';
      helpRequest = this.getHelpRequest(myForm);
      this.globals.sendSimulationMail = false;
      this.saveService.saveSimulation(helpRequest, 'Help').subscribe((data) => {
        this.dialogRef.close(true);
        this.setContactDetails(myForm);
        this.saveService.setSimulationToken(data.Tocken);
        this.saveService.setProspectNumber(data.CRMProspect);
        this.saveService.setShortToken(data.shortTocken);
        const helpConfirmationDetails = this.getHelpConfirmationDetails(helpRequest);
        this.matDialog.open(InformationDialogComponent, { data: helpConfirmationDetails, disableClose: true });
        // console.log('test');
      });
    } else {
      // console.log('invalid form');
    }
  }

  getHelpRequest(helpForm) {
    // if (this.clientIdOrSimulationTokenPresent) {
    //   return {
    //     firstName: this.firstName, lastName: this.lastName, email: helpForm.value.email,
    //     phone: helpForm.value.phone, code: helpForm.value.code, optionSalesContact: helpForm.value.simulationOptionChk
    //   };
    // } else {
      return helpForm.value;
    // }
  }

  getHelpConfirmationDetails(helpRequest) {
    return {
      firstName: helpRequest.firstName + ' ' + helpRequest.lastName,
      email: helpRequest.email,
      phone: helpRequest.phone,
      code: helpRequest.code,
      reason: helpRequest.reason,
      preference: helpRequest.preference
    };
  }

  onClose() {
    this.dialogRef.close(true);
  }

  checkInformation(myForm: NgForm, event) {
    const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code);
    this.invalidCode = location.length > 0 ? false : true;
    if (myForm.valid && !this.invalidCode) {
      if (event.target.checked) {
        this.enableHelpButton = true;
      } else {
        this.enableHelpButton = false;
      }
    }
    this.enableHelp = true;
  }

  isNumber(evt, phone) {
    if (phone === 0) {
      evt = (evt) ? evt : window.event;
      evt.preventDefault();
    } else {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((phone.length > 14) || (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode !== 43))) {
        evt.preventDefault();
      } else if (charCode === 107) {
        return true;
      } else {
        return true;
      }
    }
  }

  setContactDetails(myForm) {
    const contactData: ContactDetails = {
      FirstName: this.firstName, // myForm.value.firstName,
      Name: '',
      LastName: this.lastName, // myForm.value.lastName,
      EmailAddress: myForm.value.email,
      Telephone: myForm.value.phone,
      PostalCode: myForm.value.code,
      DateofBirth: this.dob,
      StreetName: this.street,
      StreetNumber: this.streetno,
      BoxNumber:this.boxno
    };
    this.saveService.setContactDetails(contactData);
  }
  //#endregion
}
